import { render, staticRenderFns } from "./TheAdd.vue?vue&type=template&id=2ae9be48&scoped=true"
import script from "./TheAdd.vue?vue&type=script&lang=js"
export * from "./TheAdd.vue?vue&type=script&lang=js"
import style0 from "./TheAdd.vue?vue&type=style&index=0&id=2ae9be48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae9be48",
  null
  
)

export default component.exports